<template>
	<v-tabs 
		class="round-card"
		height="34"
		background-color="background-1"
		slider-color="primary">
		<v-tab key="Sezionali" class="secondary-tab">
			Sezionali
		</v-tab>
		<v-tab key="Categorie Iva" class="secondary-tab">
			Categorie Iva
		</v-tab>
		<v-tab key="Condizioni di pagamento" class="secondary-tab">
			Condizioni di pagamento
		</v-tab>
		<v-tab key="Esclusioni pagamento" class="secondary-tab">
			Esclusioni pagamento
		</v-tab>
		<v-tab key="Conti" class="secondary-tab">
			Conti
		</v-tab>
		<v-tab key="Divisioni" class="secondary-tab">
			Divisioni
		</v-tab>
		<v-tab key="Documenti" class="secondary-tab">
			Documenti
		</v-tab>
		<v-tab v-if="$store.getters.checkModulePermissions('mailmarketing')" key="Brand" class="secondary-tab">
			Brand
		</v-tab>

		<v-tab-item class="pb-offset background-1 pt-3" key="Sezionali">
			<crud
				class="round-card"
				title='Sezionali'
				action-icon='settings'
				model-def='sectionals'
				action-position='absolute'
				crudDialog
			></crud>
		</v-tab-item>

		<v-tab-item class="pb-offset background-1 pt-3" key="Categorie Iva">
			<v-row class="ma-0 pb-offset">
				<v-col class="pa-0" cols="12">
					<crud
						title="Categorie Iva"
						action-icon='settings'
						model-def='generaltypes-vat'
						action-position='absolute'
						crudDialog
					></crud>
				</v-col>
				<v-col class="pa-0 pt-6" cols="12">
					<crud 
						title="Zone IVA"
						action-icon='settings'
						model-def='generaltypes-vat_zone'
						action-position='absolute'
						crudDialog
					></crud>
				</v-col>
			</v-row>
		</v-tab-item>

		<v-tab-item class="pb-offset background-1 pt-3" key="Condizioni di pagamento">
			<v-row class="ma-0 pb-offset">
				<v-col class="pa-0" cols="12">
					<crud
						title="Condizioni di pagamento"
						action-icon='settings'
						model-def='generaltypes-payment_term'
						action-position='absolute'
						crudDialog
					></crud>
				</v-col>
			</v-row>
		</v-tab-item>

		<v-tab-item class="pb-offset background-1 pt-3" key="Esclusioni pagamento">
			<v-row class="ma-0 pb-offset">
				<v-col class="pa-0" cols="12">
					<crud
						title="Esclusioni pagamento"
						action-icon='settings'
						model-def='generaltypes-payment_exclusion'
						action-position='absolute'
						crudDialog
					></crud>
				</v-col>
			</v-row>
		</v-tab-item>
		
		<v-tab-item class="pb-offset background-1 pt-3" key="Conti">
			<v-row class="ma-0 pb-offset">
				<v-col class="pa-0" cols="12">
					<crud
						title="Conti"
						action-icon='settings'
						model-def='generaltypes-financial_account'
						action-position='absolute'
						crudDialog
					></crud>
				</v-col>
			</v-row>
		</v-tab-item>

		<v-tab-item class="pb-offset background-1 pt-3" key="Divisioni">
			<v-row class="ma-0 pb-offset">
				<v-col class="pa-0" cols="12">
					<crud
						title="Divisioni"
						action-icon='settings'
						model-def='divisions'
						action-position='absolute'
						crudDialog
					></crud>
				</v-col>
			</v-row>
		</v-tab-item>

		<v-tab-item class="pb-offset background-1 pt-3" key="Documenti">
			<documents-settings
			></documents-settings>
		</v-tab-item>

		<v-tab-item v-if="$store.getters.checkModulePermissions('mailmarketing')" class="pb-offset background-1 pt-3" key="Brand">
			<brands-settings></brands-settings>
		</v-tab-item>
	</v-tabs>
</template>
<script>

	import DocumentsSettings from '@/components/modules/settings/DocumentsSettings'
	import BrandsSettings from '@/components/modules/settings/BrandsSettings'

	export default {
		name:'settings-other',
        components: {
            DocumentsSettings,
            BrandsSettings
        },		
		data() {
			return {

			}
		},
	}
  </script>
